type MessagePayload = {
  [key: string]: unknown
} & ({ msg: string } | { type: string })

export const sendMessageToApp = (message: MessagePayload): void => {
  if (window.ReactNativeWebView) {
    try {
      window.ReactNativeWebView.postMessage(JSON.stringify(message))
    } catch (error) {
      console.error('Erro ao enviar mensagem para o app:', error)
    }
  }
}

export const handleBackToActivities = (): void => {
  sendMessageToApp({
    msg: 'back-to-activities'
  })
}
